import { Flex, Box } from 'components/ui';
import { Row, Col } from 'react-grid-system';
import RoundedBox from 'components/Traits/RoundedBox';
import TraitsGallery from 'components/TraitsGallery';
import triangleIcon from 'img/triangle.svg';
import { TRAITS_MEDIA_FILES } from '../../constants';

interface NoteShapeProps {}

const NoteShape: React.FC<NoteShapeProps> = () => {
  return (
    <Row>
      <Col xs={12} sm={12} md={5}>
        <RoundedBox>
          <TraitsGallery
            items={[
              {
                title: 'Square',
                content: (
                  <Box>
                    <img
                      src={TRAITS_MEDIA_FILES.noteShapes.square}
                      width="100%"
                      alt="square"
                    />
                  </Box>
                ),
              },
              {
                title: 'Line',
                content: (
                  <Box>
                    <img
                      src={TRAITS_MEDIA_FILES.noteShapes.line}
                      width="100%"
                      alt="line"
                    />
                  </Box>
                ),
              },
              {
                title: 'Triangle',
                content: (
                  <Box>
                    <img
                      src={TRAITS_MEDIA_FILES.noteShapes.triangle}
                      width="100%"
                      alt="triangle"
                    />
                  </Box>
                ),
              },
            ]}
          />
        </RoundedBox>
      </Col>

      <Col id="note_shapes" xs={12} sm={12} md={7}>
        <RoundedBox minHeight="460px">
          <Flex mb={3}>
            <img src={triangleIcon} width="20px" alt="note shape icon" />
            <Box ml={3} fontWeight="bold" fontSize={3}>
              Note Shapes
            </Box>
          </Flex>
          <Box>
            As mentioned above, note shapes is a global trait, with each piece having a predefined
            shape.
          </Box>
          <Box my={3}>
            There are 3 different shapes: 1) square; 2) Line; 3 Triangle. The Futura NFT adopts the
            more predominant Note Shape among its clips.
          </Box>
          <Box>
            The Square is the most likely shape and Triangle is the most uncommon shape among them
            all.
          </Box>
        </RoundedBox>
      </Col>
    </Row>
  );
};

export default NoteShape;
